import { type SubeventTeamData, type TeamData } from '~/apps/product-plus/components/BettingInsights/types';

interface TeamInfo {
  away: string;
  home: string;
}

interface MatchupTeamInfo {
  fallbackTeamNames: { left: string; right: string };
  isHomeVsAway: boolean;
  leftTeam: TeamData | undefined;
  matchupString: string;
  rightTeam: TeamData | undefined;
}

const extractTeamsFromSubeventName = (subeventName: string): TeamInfo => {
  const teamSeparators = [' v ', ' at '] as const;

  for (const separator of teamSeparators) {
    const teams = subeventName.split(separator);
    if (teams.length === 2) {
      const [first, second] = teams.map(team => team.trim());
      return separator === ' v ' ? { away: second, home: first } : { away: first, home: second };
    }
  }

  return { away: 'Away', home: 'Home' };
};

export const getMatchupTeamInfo = ({
  categoryGroupName,
  subeventName,
  teamData,
}: {
  categoryGroupName: string;
  subeventName: string;
  teamData?: SubeventTeamData | null;
}): MatchupTeamInfo => {
  const showHomeFirst = categoryGroupName === 'FOOTBALL';
  const separator = showHomeFirst ? 'vs' : '@';

  const { away, home } = extractTeamsFromSubeventName(subeventName);

  const awayTeamShort = teamData?.away?.shortName || away;
  const homeTeamShort = teamData?.home?.shortName || home;

  const [leftTeam, rightTeam] = showHomeFirst ? [teamData?.home, teamData?.away] : [teamData?.away, teamData?.home];

  const [leftTeamName, rightTeamName] = showHomeFirst ? [homeTeamShort, awayTeamShort] : [awayTeamShort, homeTeamShort];

  const matchupString = `${leftTeamName} ${separator} ${rightTeamName}`;

  const fallbackTeamNames = {
    left: showHomeFirst ? home : away,
    right: showHomeFirst ? away : home,
  };

  return { leftTeam, rightTeam, matchupString, fallbackTeamNames, isHomeVsAway: showHomeFirst };
};
